var FilterPathSeparatorEnum = /* @__PURE__ */ ((FilterPathSeparatorEnum2) => {
  FilterPathSeparatorEnum2["Operator"] = "|";
  return FilterPathSeparatorEnum2;
})(FilterPathSeparatorEnum || {});
var FilterPathOperatorEnum = /* @__PURE__ */ ((FilterPathOperatorEnum2) => {
  FilterPathOperatorEnum2["Min"] = "min";
  FilterPathOperatorEnum2["Max"] = "max";
  FilterPathOperatorEnum2["NestedField"] = "nestedField";
  return FilterPathOperatorEnum2;
})(FilterPathOperatorEnum || {});
export {
  FilterPathOperatorEnum,
  FilterPathSeparatorEnum
};
